import React from 'react';
import { Box, Typography } from '@mui/material';

const ACTION_CONFIG = {
  create:  { label: 'Create',  bg: '#eff6ff', color: '#1d4ed8', border: '#bfdbfe' },
  edit:    { label: 'Edit',    bg: '#fffbeb', color: '#92400e', border: '#fde68a' },
  delete:  { label: 'Delete',  bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
  convert: { label: 'Convert', bg: '#eef2ff', color: '#4338ca', border: '#c7d2fe' },
};


const CONVERT_ARROW = ' → ';

export function splitConvertContentName(contentName, actionType) {
  if (actionType?.toLowerCase() !== 'convert' || !contentName) {
    return { baseName: contentName, targetLabel: null };
  }
  const idx = contentName.lastIndexOf(CONVERT_ARROW);
  if (idx === -1) return { baseName: contentName, targetLabel: null };
  return { baseName: contentName.slice(0, idx), targetLabel: contentName.slice(idx + CONVERT_ARROW.length) };
}

export default function ActionTypeChip({ actionType, targetLabel }) {
  if (!actionType) return null;
  const key = actionType?.toLowerCase();
  const formattedFallback = actionType.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
  const cfg = ACTION_CONFIG[key] ?? { label: formattedFallback, bg: '#f8fafc', color: '#475569', border: '#e2e8f0' };
  const label = key === 'convert' && targetLabel ? `Convert → ${targetLabel}` : cfg.label;
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        px: 1.25,
        py: 0.45,
        borderRadius: '6px',
        bgcolor: cfg.bg,
        border: `1px solid ${cfg.border}`,
      }}
    >
      <Typography sx={{ fontSize: '0.6875rem', fontWeight: 700, color: cfg.color, letterSpacing: '0.3px', lineHeight: 1, whiteSpace: 'nowrap' }}>
        {label}
      </Typography>
    </Box>
  );
}
